export default __webpack_public_path__ + "static/media/user-tony.ed853582.png";